import DiscoverYourParadise from "./DiscoverYourParadise";
import CopyBlock from "./CopyBlock";
import PortalList from "./PortalList";
import PortalListItem from "./PortalListItem";

export default DiscoverYourParadise;

export { DiscoverYourParadise, CopyBlock, PortalList, PortalListItem };
